// extracted by mini-css-extract-plugin
export default {"clearButton":"styles_clearButton__EPt3z"};